<template>
	<section class="modal j-popup j-omya-popup-2">
		<div class="modal__card" style="width:610px;">
			<div class="modal__image-holder">
				<img src="../../../static/images/maraphones/omya_3.jpg" width="100%" alt="" %>
			</div>
			<div class="modal__main">
				<p class="modal__text modal__text--large bold-font">Уважаемые коллеги!</p>

				<p class="modal__text">
					Пришло время для третьего этапа нашего марафона!<br />
					Мы&nbsp;идём буквально по&nbsp;пятам космонавта&nbsp;&mdash; нам не&nbsp;удалось
					найти&nbsp;его&nbsp;по&nbsp;прошлым оставленным координатам, но&nbsp;на&nbsp;посещённых
					планетах мы&nbsp;снова нашли сигнал с&nbsp;помехами:
				</p>
				<p class="modal__text">
					1)&nbsp;&nbsp;<span style="letter-spacing:1px;">MMMMMMMMMMMMMMMMMCCIV</span><br />
					2)&nbsp;&nbsp;<span style="letter-spacing:1px;">CXVII</span><br />
					3)&nbsp;&nbsp;<span style="letter-spacing:1px;">CXVI</span><br />
					4)&nbsp;&nbsp;<span style="letter-spacing:1px;">MMMMMMMMMMMMMMMMMDCCCXL</span>
				</p>
				<p class="modal__text">Разгадайте шифр и&nbsp;пройдите 4 курса, чтобы приблизиться к&nbsp;спасению нашего любознательного космонавта!</p>
				<p class="modal__text">
					Напоминаем, что правила марафона доступны по&nbsp;<a
						href="https://downloads.eduson.tv/materials/files/000/010/965/original/Регламент_марафона_Omya_(29.06.26).pdf"
						class="link-btn link-btn--underline bold-font"
						style="color: #58298b;"
						target="_blank"
						rel="noopener noreferrer"
					>ссылке.</a> Данный&nbsp;этап&nbsp;продлится до&nbsp;19 июля. <br>
					Не&nbsp;останавливайтесь на&nbsp;достигнутом!
				</p>
			</div>
			<div class="text-center" style="background-color: #1a1734;border-radius: 0 0 5px 5px;padding: 40px;">
				<button
					class="regular-btn red-white-btn bold-font j-upd-additional-info j-hide-popup"
					:data-url="upd_additional_info_path"
					data-additional-info="omya_06_26_3"
					type="button"
				>Приступить</button>
			</div>
		</div>
	</section>
</template>

<script>
export default {
	name: 'OmyaPopup2',

	props: {
		upd_additional_info_path: ''
	},
}
</script>

